import React, { useState } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { createSchedule } from "../../../../actions/Appointment/serviceAction";
import { Form, Input, Drawer, Button, Col, Row, message, Divider, Select, DatePicker, TimePicker } from "antd";
import { PlusOutlined } from "@ant-design/icons";
const { RangePicker } = DatePicker;


const CreateNewSchedule = ({
    service_id,
    createSchedule,
    setUpdatelist,
    details,
  }) => {
    const format = "h:mm a";
    const format24 = "HH:mm";
    const [entryTime, setEntryTime] = useState(moment("10:00", format));
    const [exitTime, setExitTime] = useState(moment("20:00", format));
    const [visible, setVisible] = useState(false);
    const [form] = Form.useForm();

    const showDrawer = () => {
        setVisible(true);
      };
    
    const onClose = () => {
    setVisible(false);
    form.resetFields();
    };
    
    const onFinish = (values) => {
        try {
          const value = {
            ...values,
            start_time: entryTime.format(format24),
            end_time: exitTime.format(format24),
          };
          createSchedule(value, service_id);
          console.log("Value", service_id);
          console.log("Values", value);
          setVisible(false);
          setUpdatelist(false);
          message.success(service_id + " Has been added to your service list");
          form.resetFields();
        } catch {
          message.warning("There are something wrong with the API");
        }

      };
    
    const entryTimeChange = (time) => {
      setEntryTime(time);
      console.log("enrty", time);
    };
    const exitTimeChange = (time) => {
      setExitTime(time);
    };  

      return (
        <>
          <>
            <Button
              type="primary"
              onClick={showDrawer}
              style={{ marginBottom: "10px" }}
            >
              <PlusOutlined /> Add Scheduled Services
            </Button>
            <Drawer
              title="Create a Schedule"
              width={720}
              onClose={onClose}
              visible={visible}
              bodyStyle={{ paddingBottom: 80 }}
            >
              <Form
                form={form}
                layout="vertical"
                hideRequiredMark
                onFinish={onFinish}
              >
                <Row gutter={16}>
                  <Col span={24}>
                    {/* <Form.Item
                      name="Holiday"
                      label="Holiday"
                      rules={[
                        { required: true, message: "Please enter date" },
                      ]}
                    >
                    </Form.Item> */}
                    <Form.Item
                      name="day_of_week"
                      label="On Day"
                      rules={[
                        { required: true, message: "Add your Weekday" },
                      ]}
                    >
                      <Input type="text"placeholder="Scheduled on day" />                     
                    </Form.Item>
                    
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col span={6}>
                    <Form.Item name="start_time" label="Start Time">
                      {/* <DatePicker showTime style={{ width: "100%" }} /> */}
                      <TimePicker
                        use12Hours
                        onChange={entryTimeChange}
                        defaultValue={entryTime}
                        format={format}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item name="end_time" label="End Time">
                      {/* <DatePicker showTime style={{ width: "100%" }} />   */}
                        <TimePicker
                          use12Hours
                          onChange={exitTimeChange}
                          defaultValue={exitTime}
                          format={format}
                        />
                    </Form.Item>
                  </Col>
                </Row>  
                <Form.Item>
                  <Button onClick={onClose} style={{ marginRight: 8 }}>
                    Cancel
                  </Button>
                  <Button type="primary" htmlType="submit">
                    Submit
                  </Button>
                </Form.Item>
              </Form>
            </Drawer>
          </>
        </>
      );  

  };
export default connect(null, { createSchedule }) (CreateNewSchedule);    